<script>
    import ActionButton from "./ActionButton.svelte";
    import {
      GameStateStore,
      Hearts,
      PlayerId,
      PlayersStore,
      SetupStore,
      RemoveStore,
      ItemsToPlace,
      IsTurn,
    } from "../stores/gameStore";
    import ItemCard from "./ItemCard.svelte";
    import PotionCard from "./PotionCard.svelte";
    import { SPRITES } from "../../constants/sprites";
    import { ItemMeta } from "../../constants/items";

    $: $ItemsToPlace = $ItemsToPlace;
    $: thisPlayer = $PlayerId;
    let width = 500;
    $: scale = width / SPRITES["PLAYERBOARD"].width;
    $: itemsToPlace = $ItemsToPlace;
    $: numItemsToPlace = $ItemsToPlace.length;

    const textItemsToPlace = _('New items');
    const textRemoveSelectedItems = _('Remove selected items');
</script>

<div class="container">
    <div class="items-header" style="font-weight: 600;">{textItemsToPlace}</div>
    <div class="wrapper">
        {#each itemsToPlace as card, i}
            <div
            class="cardWrapper"
            style:outline-color={ItemMeta[
                $SetupStore.data.cards[card].position || "UNDEFINED"
            ].color}
            id={''.concat(card, '_cleanup')}
            >
                <!-- REMOVE ITEMS -->
                {#if ($IsTurn) && ($GameStateStore.name === "makeSpace")}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div
                    class="decide"
                    style:outline-color={$RemoveStore.selected?.includes(card)
                        ? "red"
                        : "white"}
                    on:click={() => {
                        if ($RemoveStore?.selected?.includes(card)) {
                        $RemoveStore.selected = $RemoveStore.selected.filter(
                            (s) => s !== card
                        );
                        $RemoveStore = $RemoveStore;
                        } else {
                        if ($RemoveStore?.selected?.length === $ItemsToPlace.length) return;
                        if (!$RemoveStore.selected) $RemoveStore.selected = [];
                        $RemoveStore.selected.push(card);
                        $RemoveStore = $RemoveStore;
                        }
                    }}
                    ></div>
                {/if}

                {#if card.startsWith("P_") === false}
                    <ItemCard
                    width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
                    card={$SetupStore.data.cards[card]}
                    enhanced={0}
                    location={'cleanup'}
                    id={card}
                    />
                {:else}
                    <PotionCard
                    width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
                    card={$SetupStore.data.cards[card]}
                    active={0}
                    location={'cleanup'}
                    id={card}
                    />
                {/if}
            </div>
        {/each}
        <button
        class="btn"
        disabled={$RemoveStore?.selected?.length != numItemsToPlace}
        on:click={() => {
          window.GAME.bgaPerformAction("cleanInventory", {
            cardId01: $RemoveStore.selected[0] || 0,
            cardId02: $RemoveStore.selected[1] || 0,
            cardId03: $RemoveStore.selected[2] || 0,
          });
          RemoveStore.set({ selected: [] });
        }}>{textRemoveSelectedItems}</button
      >
    </div>
</div>
  
  
  <style>
    .container {
        display: flex;
        flex-direction: column;
        align-items: left;
    }

    .items-header {
        margin-bottom: 1rem; /* Adds some space between the text and the cards */
    }

    .wrapper {
      display: flex;
      gap: 0.25rem;
      flex-direction: row;
    }
  
    .cardWrapper {
        position: relative;
        border-radius: 10px;
        width: max-content; /* Ensures the width matches the content */
        height: auto; /* Ensures the height matches the content */
        display: inline-block; /* Keeps the card size limited to its contents */
    }

    .decide {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;
    outline: 2px solid white;
    outline-offset: 2px;
    cursor: pointer;

    &:hover {
      backdrop-filter: brightness(1.2);
    }
  }
  </style>
  